export default "__VITE_ASSET__CJ3g5gMq__"